import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/Farm-master-min.png"

const Farmmaster = () => {
  return (
    <>
      <div className="home-container">
        <Sidebar />
        <div className="home-content">
          <img
            src={image}
            alt="Farmmaster"
            className="home-image"
          />
        </div>
      </div>
    </>
  )
}

export default Farmmaster
